// TBO portal fare type names — used in Admin Flight Commission + search markup matching.
// Legacy SYT types remain IDs 1–12; TBO-specific types start at 13.

export const TBO_FARE_TYPE_COMMISSION_OPTIONS = [
  { value: 13, label: "Corporate" },
  { value: 14, label: "SME Fare" },
  { value: 15, label: "Spice Saver" },
  { value: 16, label: "Coupon" },
  { value: 17, label: "Saver (Regular)" },
  { value: 18, label: "Flexi Plus" },
  { value: 19, label: "UpFront" },
  { value: 20, label: "Publish" },
  { value: 21, label: "Spice Max" },
  { value: 22, label: "Super Saver" },
  { value: 23, label: "Supreme6E" },
  { value: 24, label: "Stretch Plus" },
  { value: 25, label: "Stretch" },
  { value: 26, label: "Lite" },
  { value: 27, label: "Value" },
  { value: 28, label: "Classic" },
  { value: 29, label: "Sale" },
  { value: 30, label: "NDC Economy" },
  { value: 31, label: "Business" },
  { value: 32, label: "Ultimate" },
  { value: 33, label: "On_Request_Fare" },
  { value: 34, label: "Private" },
  { value: 35, label: "Eco Value" },
  { value: 36, label: "Eco Classic" },
  { value: 37, label: "Eco Flex" },
  { value: 38, label: "VFR" },
  { value: 39, label: "Tactical" },
  { value: 40, label: "Publish NDC" },
  { value: 41, label: "Basic" },
  { value: 42, label: "NDC-Economy Super Saver" },
  { value: 43, label: "NDC-Economy Comfort" },
  { value: 44, label: "NDC-Economy Flex" },
  { value: 45, label: "Economy Comfort" },
  { value: 46, label: "Economy Flex" },
];

const normalizeFareTypeName = (name = "") =>
  name
    .toString()
    .trim()
    .toUpperCase()
    .replace(/\s+/g, " ");

const TBO_NAME_TO_ID = {
  CORPORATE: 13,
  "CORPORATE SELECT": 13,
  "CORPORATE VALUE": 13,
  "CORPORATE FARE": 13,
  "SME FARE": 14,
  SME: 14,
  "SME.CRPCON": 14,
  "SPICE SAVER": 15,
  "SPICE SAVER | COUPON": 15,
  COUPON: 16,
  "RETURN SPECIAL | PROMO": 16,
  "SAVER(REGULAR)": 17,
  "SAVER (REGULAR)": 17,
  "SAVER REGULAR": 17,
  SAVER: 17,
  "FLEXI PLUS": 18,
  FLEXI: 18,
  FLEX: 18,
  UPFRONT: 19,
  "STRETCH | UPFRONT": 19,
  PUBLISH: 20,
  "PUBLISH NDC": 40,
  "SPICE MAX": 21,
  PROMO: 21,
  "SUPER SAVER": 22,
  INSTANTPUR: 22,
  INST_SERIESPUR: 22,
  INST_SERIES7: 22,
  INST_SERIES2: 22,
  INST_SERIES3: 22,
  SUPREME6E: 23,
  SUPER6E: 23,
  "STRETCH PLUS": 24,
  STRETCH: 25,
  LITE: 26,
  VALUE: 27,
  "VALUE | CLASSIC": 27,
  CLASSIC: 28,
  SALE: 29,
  "NDC ECONOMY": 30,
  "NDC-ECONOMY SUPER SAVER": 42,
  "NDC-ECONOMY COMFORT": 43,
  "NDC-ECONOMY FLEX": 44,
  BUSINESS: 31,
  ULTIMATE: 32,
  ON_REQUEST_FARE: 33,
  PRIVATE: 34,
  "ECO VALUE": 35,
  "ECO CLASSIC": 36,
  "ECO FLEX": 37,
  "ECO FLEXIBLE": 37,
  VFR: 38,
  TACTICAL: 39,
  BASIC: 41,
  "ECONOMY COMFORT": 45,
  "ECONOMY FLEX": 46,
  "ECONOMY COMFORT PLUS": 45,
};

const ID_TO_LABEL = TBO_FARE_TYPE_COMMISSION_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

export const getTboFareTypeCommissionId = (fareTypeName = "") => {
  const key = normalizeFareTypeName(fareTypeName);
  return TBO_NAME_TO_ID[key] || 0;
};

export const getTboFareTypeCommissionLabel = (id) => ID_TO_LABEL[id] || "";

export const resolveFareFamilyCommissionTypeId = (fareFamily = {}) => {
  const tboId = getTboFareTypeCommissionId(fareFamily.tboFareClassificationType);
  if (tboId > 0) {
    return tboId;
  }
  return 0;
};

export const fareFamilyMatchesCommissionFareType = (
  fareFamily,
  commissionFareTypeId,
  legacyFareTypeLabel = "",
) => {
  if (!commissionFareTypeId) {
    return false;
  }

  if (fareFamily?.tboFareClassificationType) {
    const ruleLabel = getTboFareTypeCommissionLabel(commissionFareTypeId);
    if (!ruleLabel) {
      return false;
    }
    const tboName = normalizeFareTypeName(fareFamily.tboFareClassificationType);
    if (tboName && normalizeFareTypeName(ruleLabel) === tboName) {
      return true;
    }
    if (tboName && getTboFareTypeCommissionId(tboName) === commissionFareTypeId) {
      return true;
    }
    return false;
  }

  const ruleLabel = getTboFareTypeCommissionLabel(commissionFareTypeId);
  if (ruleLabel) {
    return false;
  }

  if (legacyFareTypeLabel) {
    const couponUpper = (fareFamily?.coupanType ?? "").toUpperCase();
    const legacyUpper = legacyFareTypeLabel.toUpperCase();
    return (
      couponUpper === legacyUpper ||
      couponUpper === legacyUpper.replace(/FARE$/i, "")
    );
  }

  return false;
};
